module.exports = __webpack_public_path__ + "img/emoji-fingerleft-240x240.f0268118.png";